var _style, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "82px",
    height: "82px",
    viewBox: "0 0 82 82",
    style: {
      enableBackground: "new 0 0 82 82"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#EB001C;stroke-width:1.5;}\n\t.st1{fill:#EB001C;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 41,
    cy: 41,
    r: 30.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.1,56.7h-2.3V52h2.3V56.7z M42,25.3c0,8.3-0.1,13.7-0.1,16.4c0,2.6-0.1,4.2-0.1,4.8h-1.6 c0-0.6,0-2.2-0.1-4.8c0-2.6-0.1-8.1-0.1-16.4H42z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationLarge);
export default __webpack_public_path__ + "static/media/exclamation-large.b1927cdb8c3fd32e2e08a4e7a1182110.svg";
export { ForwardRef as ReactComponent };